export default defineNuxtPlugin({
  parallel: true,
  dependsOn: ['i18n'],
  setup: async () => {
    await useAuthStore().setAccess()
  }
})
